module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MDYiIGhlaWdodD0iMjMuNzIzIiB2aWV3Qm94PSIwIDAgMTIuNzA2IDIzLjcyMyI+CiAgPHBhdGggaWQ9Ikljb25fYXdlc29tZS1mYWNlYm9vay1mIiBkYXRhLW5hbWU9Ikljb24gYXdlc29tZS1mYWNlYm9vay1mIiBkPSJNMTMuNDgzLDEzLjM0NGwuNjU5LTQuMjkzaC00LjEyVjYuMjY1YTIuMTQ3LDIuMTQ3LDAsMCwxLDIuNDItMi4zMTloMS44NzNWLjI5QTIyLjgzOSwyMi44MzksMCwwLDAsMTAuOTkxLDBDNy42LDAsNS4zODEsMi4wNTYsNS4zODEsNS43NzlWOS4wNTFIMS42MDl2NC4yOTNINS4zODFWMjMuNzIzaDQuNjQxVjEzLjM0NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjYwOSkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/blog/img/icn_facebook_black.svg
// module id = 4C8W
// module chunks = 0